import { Grid } from "@material-ui/core";
import moment from "moment";
import { FunctionComponent, useMemo } from "react";
import styled from "styled-components";
import { Score } from "../../components/score";
import { H1 } from "../../components/typography";
import { Widget } from "../../components/widget";
import { validationFields } from "../../store/common/models/fields";
import { VaultsDTO } from "../../store/vaults/models/dto";

const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

const Label = styled.span`
  font-weight: 500;
`;

export const SingleVault: FunctionComponent<{
  id: string;
  item: VaultsDTO.Responses.GetSingleVault.T;
}> = ({ item }) => {
  const { createdDate, friendlyName, numberOfEntries } = item;

  const formattedDate = useMemo(
    () => moment.utc(createdDate).local().format("yyyy-MM-DD HH:mm"),
    [createdDate]
  );

  const createdDateName = validationFields.createdDate.useName();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StyledWidget title="Overview">
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <H1>{friendlyName}</H1>
                  </Grid>
                  <Grid item xs={6}>
                    <Label>{createdDateName}:</Label>
                  </Grid>
                  <Grid item xs={6}>
                    {formattedDate}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Score title="Size" value={numberOfEntries} size="large" />
              </Grid>
            </Grid>
          </StyledWidget>
        </Grid>
      </Grid>
    </>
  );
};
